{
  "AllNotifications": "Todas as notificações",
  "NoLinkNotification": "Nenhum link disponível para essa notificação",
  "ViewAllAnnouncementTab": "Anúncios",
  "ViewallNotificationTab": "Notificações",
  "preferences": "Editar preferências"
}
